import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white py-10" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "pt-4 text-left max-w-xl" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Major Outage Support ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-gotham-medium text-2xl pl-4" }, "+", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Major Outage Support ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-gotham-medium text-2xl pl-4" }, "-", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-lg" }, "Our Support During Unplanned Major Outages", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, "We understand how disruptive and frustrating unplanned major outages can be, as it impacts internet, VoIP phone services and streaming services. They are often a result of one, or a combination of, the following reasons:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-2" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-disc ml-6" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Network Failures – system or equipment malfunction"),
    /*#__PURE__*/_createElementVNode("li", null, "Fibre Cuts"),
    /*#__PURE__*/_createElementVNode("li", null, "Power Outages"),
    /*#__PURE__*/_createElementVNode("li", null, "Adverse Weather Conditions")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, "The Telecommunications (Customer Communications for Outages) Industry Standard 2024 defines a ‘major outage’ as one that affects — or is likely to affect—100,000 operating services or all services that use a telecommunications network in an Australian state or territory and will last (or is expected to last) for more than 60 minutes.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, [
  /*#__PURE__*/_createTextVNode("When Harbour ISP becomes aware of a major unplanned outage, we will let you know via email, SMS, on our website Outages page and the "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://my.harbourisp.com.au" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "underline" }, "Customer Portal")
  ]),
  /*#__PURE__*/_createTextVNode(" page.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, "Our outage notifications will contain at least the following information:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-2" }, [
  /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal ml-6" }, [
    /*#__PURE__*/_createElementVNode("li", null, "the scale or suspected scale of the major outage;"),
    /*#__PURE__*/_createElementVNode("li", null, "the cause or likely cause of the major outage;"),
    /*#__PURE__*/_createElementVNode("li", null, "the geographic areas impacted or likely to be impacted by the major outage;"),
    /*#__PURE__*/_createElementVNode("li", null, "the types of carriage services impacted or likely to be impacted by the major outage;"),
    /*#__PURE__*/_createElementVNode("li", null, "the estimated timeframes for updates in relation to the major outage; "),
    /*#__PURE__*/_createElementVNode("li", null, "the estimated timeframe for rectification of the major outage;"),
    /*#__PURE__*/_createElementVNode("li", null, "contact information such as an email address, a phone number or social media account details;"),
    /*#__PURE__*/_createElementVNode("li", null, "a website or webpage that is accessible to the public; and"),
    /*#__PURE__*/_createElementVNode("li", null, "details of easily accessible contact channels you can use to contact us")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, "Note:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-2" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-disc ml-6" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Harbour ISP may withhold certain information if we have reasonable grounds to believe that providing that information could compromise our network security or national security."),
    /*#__PURE__*/_createElementVNode("li", null, "Harbour ISP is not required to meet its full communication obligations in the event of a natural disaster.")
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, "While the outage is ongoing, we will provide real-time updates via our website’s Outages page and Customer Portal as well as via SMS and email. We will aim to provide updates every 4 hours as reasonably possible, or sooner if there is a significant development. As a minimum, we will provide updates every 6 hours, during the first 24-hour period and once during each subsequent 24-hour period", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, [
  /*#__PURE__*/_createTextVNode("Our Customer Service number will be updated with an acknowledgment of the outage. If you need to reach us throughout the outage for an emergency reason, please call us on 1300 579 403 during our "),
  /*#__PURE__*/_createElementVNode("a", { href: "/#contact" }, "Customer Service Operating Hours"),
  /*#__PURE__*/_createTextVNode(" or email us at support@harbourisp.com.au. Please be aware that there may be long wait times before you are able to speak to us.")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-sm pt-4" }, "Once the outage has been resolved, we will let you know via all the communication channels mentioned above.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-medium text-2xl pt-4 cursor-pointer" }, " - ", -1)
const _hoisted_23 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "w-full flex lg:flex-row flex-col mt-6" }
const _hoisted_25 = { class: "w-full lg:w-1/2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-bold mt-0 max-w-2xl text-xl" }, "Current Outages", -1)
const _hoisted_27 = {
  key: 1,
  class: "font-gotham-medium sm:mt-2 max-w-xl text-lg text-gray-700 pt-2"
}
const _hoisted_28 = { class: "w-full lg:w-1/2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "font-gotham-bold mt-12 lg:mt-0 max-w-2xl text-xl" }, "Scheduled Outages", -1)
const _hoisted_30 = {
  key: 1,
  class: "font-gotham-medium sm:mt-2 max-w-xl text-lg text-gray-700 pt-2"
}

import HeroText from '../components/content/HeroText.vue';
import Container from '../components/content/Container.vue';
import OutageList from '../components/content/OutageList.vue';
import store from '@/store';
import { ChevronRightIcon, ChevronDownIcon } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showMajorOutagePolicy = ref(false);

const outageList = computed(() => {
  return store.state.outages;
});

const toggleMajorOutagePolicy = () => {
  showMajorOutagePolicy.value = !showMajorOutagePolicy.value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createVNode(HeroText, {
          title: "Outages",
          subtitle: "Check our current and scheduled outages here"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!showMajorOutagePolicy.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "font-gotham-bold sm:mt-2 max-w-2xl text-xl cursor-pointer items-baseline flex",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleMajorOutagePolicy()))
                  }, _hoisted_6))
                : _createCommentVNode("", true),
              (showMajorOutagePolicy.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "font-gotham-bold sm:mt-2 max-w-2xl text-xl cursor-pointer items-baseline flex",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleMajorOutagePolicy()))
                  }, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            (showMajorOutagePolicy.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "max-w-5xl pt-4 pb-8 px-8 mb-10",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleMajorOutagePolicy()))
                }, _hoisted_23))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              (_unref(outageList) && _unref(outageList).currentOutages && _unref(outageList).currentOutages.length > 0)
                ? (_openBlock(), _createBlock(OutageList, {
                    key: 0,
                    outages: _unref(outageList).currentOutages
                  }, null, 8, ["outages"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_27, " No current outages. "))
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              (_unref(outageList) && _unref(outageList).scheduledOutages && _unref(outageList).scheduledOutages.length > 0)
                ? (_openBlock(), _createBlock(OutageList, {
                    key: 0,
                    outages: _unref(outageList).scheduledOutages
                  }, null, 8, ["outages"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_30, " No scheduled outages. "))
            ])
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})